<nz-drawer
    [nzClosable]="true"
    [nzVisible]="open"
    nzPlacement="right"
    [nzWidth]="_mobile() ? '100%' : '800px'"
    [nzBodyStyle]="{ position: 'relative' }"
    nzTitle="Выберите значок"
    [nzTitle]="titleTpl"
    (nzOnClose)="close()">
    <ng-container *nzDrawerContent>
        <div class="layout start-aligned fit wrap scroll-y">
            <vz-temp-info class="m05" type="info" storeId="select-tags-drawer-1">
                <div class="txt">
                    Поля для отметки у уникальных групп и вложенных тегов (можно назначить только один тег в пределах этой группы) подсвечены <span class="txt-warn">желто-оранжевым цветом</span>.
                    Теги, доступность которых ограничена проектом, отмечены беджиком с аббревиатурой проекта.
                </div>
            </vz-temp-info>
            <vz-tags-tree class="w100"
                [canEditOrg]="granted['org.admin']"
                [canEditProj]="canEditProj"
                [noEditToggle]="noEditToggle()"
                [projectId]="projectId()"
                [mode]="mode()"
                [showOrgTags]="showOrgTags()"
                [noHeader]="noHeader()"
                [noCreateButton]="noCreateButton()"
                [showAllProjects]="showAllProjects()"
                [(selected)]="selected" />
        </div>
    </ng-container>
    <ng-template #titleTpl>
        <div class="layout center ">
            <span class="flex">{{ mode() == 'normal' ? 'Теги' : 'Выберите тег' + (mode() == 'multiselect' ? 'и' : '') }}</span>
            @if (mode() == 'multiselect') {
                <span class="txt-pl mh1">выбрано: {{ selected()?.length || 0 }}</span>
                <button nz-button nzType="primary" [disabled]="cantBeEmpty() && !selected()?.length" (click)="close(selected() || [])">Сохранить</button>
            }
        </div>
    </ng-template>
</nz-drawer>
